<template>
    <div id="product-listing-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData && moduleData.ProductType" :class="moduleData.Spacing" :id="moduleData.AnchorID">
            <div class="product-types">
                <h2 class="link" :class="{active: getProductType === 'Wine'}" @click="setProductType('Wine')">Wine</h2>
                <h2 class="divider">-</h2>
                <h2 class="link" :class="{active: getProductType === 'Gift'}" @click="setProductType('Gift')">Gifts</h2>
                <h2 class="divider">-</h2>
                <!--                <h2 class="link" :class="{active: getProductType === 'Cheese'}" @click="setProductType('Cheese')">Cheese</h2>-->
                <h2 class="link" :class="{active: getProductType === 'Voucher'}" @click="setProductType('Voucher')">Vouchers</h2>
            </div>
            <div class="listing-container" :class="{empty: getLoadingProducts}" v-if="getProductType">
                <div v-if="!getLoadingProducts">
                    <div class="product-categorization">
                        <hr>
                        <div class="left">
                            <div v-if="getCategories && getCategories.length > 1">
                                <label for="category-filter">Category</label>
                                <v-select id="category-filter"
                                          v-model="getProductFilter.category"
                                          :options="getCategories"
                                          :clearable="false"
                                          placeholder="All Categories"
                                          @input="applyFilter(getProducts)">
                                </v-select>
                            </div>
                            <div v-if="getVarieties && getVarieties.length > 1">
                                <label for="variety-filter">Variety</label>
                                <v-select id="variety-filter"
                                          v-model="getProductFilter.variety"
                                          :options="getVarieties"
                                          :clearable="false"
                                          placeholder="All Varieties"
                                          @input="applyFilter(getProducts)">
                                </v-select>
                            </div>
                        </div>
                        <div class="right">
                            <p>{{ getFilteredProducts.length }} Items</p>
                            <div>
                                <label for="product-sort">Sort</label>
                                <v-select id="product-sort"
                                          v-model="getProductFilter.sort"
                                          :options="['Recommended', 'Price (low to high)', 'Price (high to low)', 'Alphabetical']"
                                          :clearable="false"
                                          @input="applySort(getFilteredProducts)">
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="product-list">
                        <b-row v-if="paginatedProducts.length">
                            <b-col class="product" md="6" lg="4" xl="3" v-for="(item, index) in paginatedProducts" :key="'product' + index"
                                   :style="staggerProducts(index)">
                                <a :href="item.Link"> <!--  @click.prevent="productClickTracking(item)" -->
                                    <div class="tags" v-if="item.Tags">
                                        <div class="tag" v-for="(tag,index) in item.Tags" :class="tag.ColourClass">
                                            <p>
                                                <span :class="{small: tag.Subtitle}">{{ tag.Title }}</span>
                                                <span class="large" v-if="tag.Subtitle">{{ tag.Subtitle }}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <img v-if="item.Image && item.Image.ID" :src="item.Image.URL"/>
                                    <div class="description">
                                        <p class="name">{{ item.Title }}</p>
                                        <template v-if="item.LocalisedPrice > 0">
                                            <p class="price" :class="{slashed: item.DiscountedPrice !== item.LocalisedPrice}">
                                                ${{ item.LocalisedPrice.toFixed(2) }} <span>{{ item.Currency }}</span></p>
                                            <p class="price" v-if="item.DiscountedPrice !== item.LocalisedPrice">
                                                ${{ item.DiscountedPrice.toFixed(2) }} <span>{{ item.Currency }}</span></p>
                                        </template>
                                    </div>
                                </a>
                                <div class="actions" v-if="getProductType !== 'Voucher'">
                                    <AddToCart icon='fa-cart-plus' :product="item"/>
                                </div>
                            </b-col>
                        </b-row>
                        <div class="empty" v-else><p>No products found, try filtering the products differently.</p></div>
                    </div>
                    <button class="btn btn-dark" v-if="showLoadMore" @click="loadMore">Load More</button>
                </div>
                <Loading v-else/>
            </div>
        </div>
        <Loading v-else/>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AddToCart from '../ecommerce/AddToCart';
import Loading from '../Loading';

export default {
    name: "ProductListingElement",
    props: {
        component: {
            type: Object,
        }
    },
    components: {
        AddToCart,
        Loading
    },
    computed: {
        ...mapGetters(['getModuleData', 'getProductType', 'getLoadingProducts', 'getProducts', 'getFilteredProducts', 'getCategories', 'getVarieties', 'getProductFilter', 'getProductLimit']),
        showLoadMore() {
            return this.getProductLimit < this.getFilteredProducts.length;
        },
        paginatedProducts() {
            let limit = this.getProductLimit;
            return this.getFilteredProducts.slice(0, parseFloat(limit));
        },
        moduleData() {
            let data = this.getModuleData(this.component.ID);
            if (data && data.ProductType && !this.getProductType) {
                //set page size
                let pageSize = data.PageSize;
                if (pageSize > 4) {
                    this.setProductPageSize(data.PageSize);
                }

                //set product type
                this.setProductType(data.ProductType);
            }
            return data;
        }
    },
    methods: {
        ...mapActions(['setProductType', 'setProductPageSize', 'applyFilter', 'applySort', 'loadMore']),
        staggerProducts(index) {
            return {'--animation-order': index}
        },
        productClickTracking(product, index) {
            /*if (this.$gtm.enabled()) {
                window.dataLayer?.push({ecommerce: null});
                window.dataLayer?.push({
                    'event': 'productClick',
                    'ecommerce': {
                        'click': {
                            'actionField': {'list': 'Search Results'},      // Optional list property.
                            'products': [{
                                'name': product.Title,                      // Name or ID is required.
                                'id': product.ID,
                                'price': product.LocalisedPrice,
                                'category': product.ProductType,
                                'position': index
                            }]
                        }
                    },
                    'eventCallback': function () {
                        document.location = product.Link
                    }
                });
            }*/
        }
    }
}
</script>
